import Vue from "vue";
import Router from "vue-router";

const Login = () => import("@/pages/login/login");
const Page403 = () => import("@/pages/403/page-403");
const Page404 = () => import("@/pages/404/page-404");
const Page500 = () => import("@/pages/500/page-500");
const Page1 = () => import("@/pages/page1");
const Page2 = () => import("@/pages/page2");
const Page3 = () => import("@/pages/page3");
const register = () => import("@/pages/register/register");
const securityProtocolPage = () =>
  import("@/pages/register/security-protocol-page");
const privateProtocolPage = () =>
  import("@/pages/register/private-protocol-page");
const registerModify = () => import("@/pages/register/registerModify");
const home = () => import("@/pages/home");
const FindPassWord = () => import("@/pages/FindPassWord");
const myupload = () => import("@/pages/test/myupload");
// 我的信息页面
const personalInfo = () => import("@/pages/personalInfo/personalInfo");

// 个人中心
const personalHome = () => import("@/pages/personalCenter/personalHome");
const appCreate = () => import("@/pages/personalCenter/appCreate");
const appApprove = () => import("@/pages/personalCenter/appApprove");
const appOverview = () => import("@/pages/personalCenter/appOverview");
const appUpdate = () => import("@/pages/personalCenter/appUpdate");
const appCheck = () => import("@/pages/personalCenter/appCheck");
const appAbstract = () => import("@/pages/personalCenter/appAbstract");
/* 应用概括 */
const appSummary = () => import("@/pages/appManage/app-summary");
/* 应用授权 */
const appAuthority = () => import("@/pages/appManage/app-authority");

// API网关
const apiApplyOverview = () => import("@/pages/apiManage/apiApplyOverview");
const apiApplyDebugCode = () => import("@/pages/apiManage/apiApplyDebugCode");
// 数据范围申请
/* const dataScopeApplyOverview = () => import('@/pages/dataScopeManage/dataScopeApplyOverview') */
const sensitiveDataManage = () =>
  import("@/pages/sensitiveDataManage/sensitiveDataManage");
const exchangeDataManage = () =>
  import("@/pages/exchangeDataManage/exchangeDataManage");

// 文档中心
const documentCenter = () => import("@/pages/documentCenter/documentCenter");
const documentManage = () => import("@/pages/document/documentManage");
// 平台介绍
const platformIntroduction = () =>
  import("@/pages/documentCenter/components/platformIntroduction/introduction");
// 开发者注册流程
const accountRegistration = () =>
  import(
    "@/pages/documentCenter/components/registrationFlows/accountRegistration"
  );
const accountAuthentication = () =>
  import(
    "@/pages/documentCenter/components/registrationFlows/accountAuthentication"
  );
const completeRegistration = () =>
  import(
    "@/pages/documentCenter/components/registrationFlows/completeRegistration"
  );
const platformRegistration = () =>
  import(
    "@/pages/documentCenter/components/registrationFlows/platformRegistration"
  );

// 应用创建流程
const appCreateFlows = () =>
  import("@/pages/documentCenter/components/appCreateFlows/appCreateFlows");
const appAuthorization = () =>
  import("@/pages/documentCenter/components/appCreateFlows/appAuthorization");
const appStartsell = () =>
  import("@/pages/documentCenter/components/appCreateFlows/appStartsell");
const h5App = () =>
  import("@/pages/documentCenter/components/appCreateFlows/h5App");
const webApp = () =>
  import("@/pages/documentCenter/components/appCreateFlows/webApp");

// 接口规范 interfaceDebugging
const interfaceSpecification = () =>
  import(
    "@/pages/documentCenter/components/interfaceSpecification/interfaceSpecification"
  );
const interfaceDebugging = () =>
  import("@/pages/documentCenter/components/interfaceSpecification/debugging");
const sensitiveData = () =>
  import(
    "@/pages/documentCenter/components/interfaceSpecification/sensitiveData"
  );
const interfaceSSO = () =>
  import("@/pages/documentCenter/components/interfaceSpecification/sso");

// API
// const APIexplain = () => import('@/pages/documentCenter/components/api/APIexplain')
// const apiDetail = () => import('@/pages/document/serviceDocument/api/apiDetail')
// FAQ
const FAQ = () => import("@/pages/documentCenter/components/faq/faq");
const Logout = () => import("@/pages/login/logout");

// const developDocument = () => import('@/pages/developDocument/index')

/* 申请授权管理 */
const applyAuthority = () => import("@/pages/appManage/apply-authority");
Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: '/uploadtest',
    //   name :  'uploadtest',
    //   component : myupload,
    //   meta : {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    // },
    {
      path: "/",
      redirect: "/home",
      meta: { requiresAuth: false, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/page403",
      name: "Page403",
      component: Page403,
      meta: { requiresAuth: false, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/page404",
      name: "Page404",
      component: Page404,
      meta: { requiresAuth: false, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/page500",
      name: "Page500",
      component: Page500,
      meta: { requiresAuth: false, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { requiresAuth: false, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout,
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "教育云开放平台",
        headType: "none"
      }
    },
    {
      path: "/page1",
      name: "Page1",
      component: Page1,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/page2",
      name: "Page2",
      component: Page2,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/page3",
      name: "Page3",
      component: Page3,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" } // 注册需要auth,因为文件上传地址耦合在里面了。
    },
    {
      path: "/security-protocol-page",
      name: "securityProtocolPage",
      component: securityProtocolPage,
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "讯飞教育云开放平台开发者协议"
      }
    },
    {
      path: "/private-protocol-page",
      name: "privateProtocolPage",
      component: privateProtocolPage,
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "科大讯飞用户隐私权政策"
      }
    },
    {
      path: "/home",
      name: "home",
      component: home,
      meta: { requiresAuth: false, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/FindPassWord",
      name: "FindPassWord",
      component: FindPassWord,
      meta: { requiresAuth: false, needConfirm: false, title: "教育云开放平台" }
    },
    // 我的信息页面
    {
      path: "/personalInfo",
      name: "personalInfo",
      component: personalInfo,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },

    // 个人中心
    {
      path: "/personalHome",
      name: "personalHome",
      component: personalHome,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/appCreate",
      name: "appCreate",
      component: appCreate,
      meta: { requiresAuth: true, needConfirm: true, title: "教育云开放平台" }
    },
    {
      path: "/appApprove",
      name: "appApprove",
      component: appApprove,
      meta: { requiresAuth: true, needConfirm: true, title: "教育云开放平台" }
    },
    {
      path: "/appUpdate",
      name: "appUpdate",
      component: appUpdate,
      meta: { requiresAuth: true, needConfirm: true, title: "教育云开放平台" }
    },
    {
      path: "/appCheck",
      name: "appCheck",
      component: appCheck,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/appAbstract",
      name: "appAbstract",
      component: appAbstract,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/documentManage",
      name: "documentManage",
      component: documentManage,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    /* {
      path: '/appOverview',
      name: 'appOverview',
      component: appOverview,
      meta: {requiresAuth: true,needConfirm:false,title: '教育云开放平台'}
    }, */
    /* 应用概括信息 */
    {
      path: "/appSummary",
      name: "appSummary",
      component: appSummary,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    /* 应用授权 */
    {
      path: "/appAuthority",
      name: "appAuthority",
      component: appAuthority,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/applyAuthority",
      name: "applyAuthority",
      component: applyAuthority,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/registerModify",
      name: "registerModify",
      component: registerModify,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/apiApplyOverview",
      name: "apiApplyOverview",
      component: apiApplyOverview,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/apiApplyDebugCode/:apiId/:appId",
      name: "apiApplyDebugCode",
      component: apiApplyDebugCode,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/sensitiveDataManage",
      name: "sensitiveDataManage",
      component: sensitiveDataManage,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    {
      path: "/exchangeDataManage",
      name: "exchangeDataManage",
      component: exchangeDataManage,
      meta: { requiresAuth: true, needConfirm: false, title: "教育云开放平台" }
    },
    /* {
      path: '/dataScopeApplyOverview',
      name: 'dataScopeApplyOverview',
      component: dataScopeApplyOverview,
      meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    } */

    // 文档中心 documentCenter platformIntroduction
    // {
    //   path: '/documentCenter',
    //   name: 'documentCenter',
    //   component: documentCenter,
    //   meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'},
    //   redirect: "/documentCenter/platformIntroduction",
    //   children: [
    //     {
    //       path: 'platformIntroduction',
    //       name: 'platformIntroduction',
    //       component: platformIntroduction,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'accountRegistration',
    //       name: 'accountRegistration',
    //       component: accountRegistration,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'accountAuthentication',
    //       name: 'accountAuthentication',
    //       component: accountAuthentication,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'completeRegistration',
    //       name: 'completeRegistration',
    //       component: completeRegistration,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'platformRegistration',
    //       name: 'platformRegistration',
    //       component: platformRegistration,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     // 应用创建流程
    //     {
    //       path: 'appCreateFlows',
    //       name: 'appCreateFlows',
    //       component: appCreateFlows,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'webApp',
    //       name: 'webApp',
    //       component: webApp,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'h5App',
    //       name: 'h5App',
    //       component: h5App,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'appStartsell',
    //       name: 'appStartsell',
    //       component: appStartsell,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'appAuthorization',
    //       name: 'appAuthorization',
    //       component: appAuthorization,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     // 接口规范
    //     {
    //       path: 'interfaceSpecification',
    //       name: 'interfaceSpecification',
    //       component: interfaceSpecification,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'interfaceDebugging',
    //       name: 'interfaceDebugging',
    //       component: interfaceDebugging,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'sensitiveData',
    //       name: 'sensitiveData',
    //       component: sensitiveData,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     {
    //       path: 'interfaceSSO',
    //       name: 'interfaceSSO',
    //       component: interfaceSSO,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //     // API APIexplain
    //     {
    //       path: 'APIexplain/:groupId',
    //       name: 'APIexplain',
    //       component: APIexplain,
    //       meta: {requiresAuth: false}
    //     },
    //     {
    //       path: 'apiDetailIndex/:apiId',
    //       name: 'apiDetailIndex',
    //       component: () => import('@/pages/documentCenter/components/api/apiDetail/index'),
    //       meta: {requiresAuth: false},
    //       redirect: "apiDetailIndex/apiDetail",
    //       children: [
    //         {
    //           path: 'apiDetail/:apiId',
    //           name: 'apiDetail',
    //           component: () => import('@/pages/documentCenter/components/api/apiDetail/apiDetail'),
    //           meta: {requiresAuth: false},
    //         },
    //         {
    //           path: 'objectInfo/:entityId',
    //           name: 'objectInfo',
    //           component: () => import('@/pages/documentCenter/components/api/apiDetail/object-info/objectInfo'),
    //           meta: {requiresAuth: false}
    //         },
    //       ]
    //     },
    //     // FAQ
    //     {
    //       path: 'FAQ',
    //       name: 'FAQ',
    //       component: FAQ,
    //       meta: {requiresAuth: false,needConfirm:false,title: '教育云开放平台'}
    //     },
    //   ],
    // },
    {
      path: "/baseDocument",
      name: "baseDocument",
      component: () => import("@/pages/document/baseDocument/baseDocument"),
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "基础文档",
        headType: "document"
      }
    },
    {
      path: "/ssoDocument",
      name: "ssoDocument",
      component: () =>
        import("@/pages/document/serviceDocument/ssoDocument.vue"),
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "统一用户认证",
        headType: "document"
      }
    },
    {
      path: "/apiDocument",
      name: "apiDocument",
      component: () =>
        import("@/pages/document/serviceDocument/apiDocument.vue"),
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "API接入",
        headType: "document"
      }
    },
    {
      path: "/miniProgramDocument",
      name: "miniProgramDocument",
      component: () =>
        import("@/pages/document/serviceDocument/miniProgramDocument.vue"),
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "小程序",
        headType: "document"
      }
    },
    {
      path: "/dataExchangeDocument",
      name: "dataExchangeDocument",
      component: () =>
        import("@/pages/document/serviceDocument/dataExchangeDocument.vue"),
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "数据交换",
        headType: "document"
      }
    },
    {
      path: "/searchDocument",
      name: "searchDocument",
      component: () => import("@/pages/document/search.vue"),
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "文档搜索",
        headType: "document"
      }
    },
    {
      path: "/standardDocument",
      name: "standardDocument",
      component: () =>
        import("@/pages/document/standardDocument/standardDocument.vue"),
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "平台规范",
        headType: "document"
      }
    },
    {
      path: "/appendixDocument",
      name: "appendixDocument",
      component: () =>
        import("@/pages/document/appendixDocument/appendixDocument.vue"),
      meta: {
        requiresAuth: false,
        needConfirm: false,
        title: "附录",
        headType: "document"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js